import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  colors,
  Avatar,
  Checkbox,
  TablePagination,
  Select,
  Typography,
  MenuItem,
  Tabs
} from '@material-ui/core';
import getInitials from 'utils/getInitials';
import EditIcon from '@material-ui/icons/Edit';
import { IconButton } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import Api from '../../../Helpers/ApiHandler';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { Label } from 'components';
var api = new Api();

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 700
  },
  progressContainer: {
    padding: theme.spacing(3),
    display: 'flex',
    justifyContent: 'center'
  },
  actions: {
    justifyContent: 'flex-end'
  },
  arrowForwardIcon: {
    marginLeft: theme.spacing(1)
  }
}));


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>

    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const InTransist = "InTransist";

const paymentStatusColors = {
  Processing: colors.grey[600],
  Pending: colors.orange[600],
  Delivered: colors.green[600],
  InTransist: colors.blue[600],
  Canceled: colors.red[600]
};

const LatestOrders = props => {
  const { className, ...rest } = props;

  const [orders, setOrders] = useState([]);
  const classes = useStyles();
  const [user, setUser] = useState("");
  const [orderId, setOrderId] = useState("");
  const [open, setOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sessionMessage, setSessionMessage] = useState({ message: "", type: "", open: false })
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setpage] = useState(1);
  const [count, setcount] = useState(0);
  const [pageSize, setpageSize] = useState(5);
  const [pageSizes, setpageSizes] = useState([5, 10, 15]);
  const [totalItems, settotalItems] = useState(0);
  const [filterOption, setfilterOption] = useState({});
  const [searchTitle, setsearchTitle] = useState("");
  const [status, setStatus] = useState("All")

  const handleStatusClose = () => {
    setStatusOpen(false);
  };
  const [statusOpen, setStatusOpen] = useState(false);
  const handleDialogClose = () => {
    setOpen(false);
  };
  const handleClose = (event, reason) => {
    setSessionMessage({ message: "", type: "", open: false })
  };

  const handleDeleteClickOpen = (id) => {
    setOrderId(id);
    setOpen(true);

    const fetchCustomers = () => {
      api.post(`admin/SingleOrder/${id}`).then(result => {
        setUser(result.data.user);
      }).catch((err) => {
        setSessionMessage({ message: "there is something error", type: "error", open: true })
      })
    };
    fetchCustomers();
  };

  useEffect(() => {
    fetchRecords(page, pageSize, filterOption);
  }, [page, pageSize]);


  const fetchRecords = (page, pageSize, filterOption) => {
    filterOption['size'] = pageSize;
    filterOption['page'] = page - 1;
    filterOption['status'] = "";
    api.get('admin/AllOrders', { params: filterOption }).then(result => {
      if (result.success == "true") {
        const { orders, totalPages, totalItems, currentPage } = result.data;
        setOrders(orders);
        setcount(totalPages);
        settotalItems(totalItems);
        setLoading(false);
      } else {
        setSessionMessage({ message: "server time out!!", type: "error", open: true })
      }
    }).catch((err) => {
      setSessionMessage({ message: "there is something error", type: "error", open: true })
    })
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        title="Latest Orders"
      />
      <Divider />
      <CardContent className={classes.content}>
        <PerfectScrollbar options={{ suppressScrollY: true }}>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell>Ref</TableCell>
                  <TableCell>Customer</TableCell>
                  <TableCell>Qty</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell alignItems="center">Status</TableCell>
                  <TableCell alignItems="center">Actions</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {orders.map(order => (
                  <TableRow
                    key={order.id}
                  >
                    <TableCell>#</TableCell>
                    <TableCell >
                      <div style={{ display: 'flex' }}>
                        <div>
                          <Avatar
                            className={classes.avatar}
                            src={order.url ? order.url : ""}
                          >
                            {getInitials(order.user ? order.user : "")}
                          </Avatar>
                        </div>
                        <div style={{ marginTop: '10px', marginLeft: "10px" }}>{order.title}</div>
                      </div>
                    </TableCell>
                    <TableCell>
                      {order.order_number} | {`BELSUB00000${order.id}`}
                      <Typography variant="body2">
                        {order.createdAt ? order.createdAt : ""}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ color: "navy" }}><a onClick={() => handleDeleteClickOpen(order.order_id)}>{order.user ? order.user : ""}</a></TableCell>
                    <TableCell>{order.qty ? order.qty : ""}</TableCell>
                    <TableCell>{order.price ? order.price : ""}</TableCell>
                    <TableCell alignItems="center">
                      <Label
                        color={order.single_catalog_status == "In Transist" ? paymentStatusColors[InTransist] : paymentStatusColors[order.single_catalog_status]}
                        variant="outlined"
                      >
                        {order.single_catalog_status ? order.single_catalog_status : ""}
                      </Label>
                    </TableCell>
                    <TableCell alignItems="center">
                      <Button
                        color="primary"
                        component={RouterLink}
                        size="small"
                        to={`/management/orders/${order.order_id}`}
                        variant="outlined"
                      >
                        View
                        </Button>

                    </TableCell>
                  </TableRow>
                ))}
                {orders.length === 0 ?
                  <TableRow>
                    <TableCell style={{ textAlign: 'center' }} colSpan="7">No records found!!</TableCell>
                  </TableRow>
                  : ''}
              </TableBody>

            </Table>

            {user &&

              <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                style={{ minWidth: '500px !important' }}
              >
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                  Customer Information
                      </DialogTitle>
                <DialogContent dividers>
                  <div>
                    <Avatar
                      className={classes.avatar}
                      src={user ? user.profileImage : ""}
                    >
                      {getInitials(user ? user.profileImage : "")}
                    </Avatar>
                  </div>

                  <Typography className={classes.userSpacing}>
                    Name : {user.name ? user.name : ""}
                  </Typography>
                  <Typography className={classes.userSpacing}>
                    Phone : {user.phone ? user.phone : ""}
                  </Typography>
                  <Typography className={classes.userSpacing}>
                    Email : {user.email ? user.email : ""}
                  </Typography>
                  <Typography className={classes.userSpacing}>
                    Address : {user.address_1 + " " + user.city + " " + user.state + " " + user.pincode}
                  </Typography>
                  <Typography className={classes.userSpacing}>
                    Firm Name : {user.firm_name ? user.firm_name : ""}
                  </Typography>
                  <Typography className={classes.userSpacing}>
                    Gst Number : {user.gst_number ? user.gst_number : ""}
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleDialogClose} style={{ float: 'right' }} color="secondary">
                    no
                        </Button>
                </DialogActions>
              </Dialog>
            }
            <Dialog
              open={statusOpen}
              onClose={handleStatusClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{"Are you sure you want to change order's status?"}</DialogTitle>

              <DialogActions>
                <Button onClick={handleStatusClose} color="primary">
                  Yes
          </Button>
                <Button onClick={handleStatusClose} color="primary" autoFocus>
                  No
          </Button>
              </DialogActions>
            </Dialog>

          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button
          color="primary"
          component={RouterLink}
          size="small"
          to="/orders"
          variant="text"
        >
          See all
          <ArrowForwardIcon className={classes.arrowForwardIcon} />
        </Button>
      </CardActions>
    </Card>
  );
};

LatestOrders.propTypes = {
  className: PropTypes.string
};

export default LatestOrders;
